<div (click)="openPopup($event)" tappable>{{ valueState() | durationTime }}</div>

